<div *ngIf="steps.length > 0 && currentStep != -1">
    <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12 md:col-span-7">
            <div class="card box">
                <div class="m-6">
                    <div *ngIf="currentStep == 1">
                        <!-- Step: Willkommen -->
                        <h2 class="mb-6">Hey, {{ name }} 👋</h2>
                        <p class="mb-2" [innerHTML]="'onboarding_step1_intro' | translate"></p>
                        <br />
                        <div class="flex justify-between">
                            <div>
                                <p>
                                    <b>{{ "onboarding_welcome_subheading" | translate }}</b>
                                </p>
                                <div class="flex ml-4 mb-4">
                                    <div>
                                        <img src="/assets/images/check-square.svg" alt="check" width="80%" height="105%" />
                                    </div>
                                    <div class="ml-2 my-1">{{ "onboarding_welcome_2" | translate }}</div>
                                </div>
                                <div class="flex ml-4 mb-4">
                                    <div>
                                        <img src="/assets/images/check-square.svg" alt="check" width="80%" height="105%" />
                                    </div>
                                    <div class="ml-2 my-1">{{ "onboarding_welcome_1" | translate }}</div>
                                </div>
                                <div class="flex ml-4 mb-4">
                                    <div>
                                        <img src="/assets/images/check-square.svg" alt="check" width="80%" height="105%" />
                                    </div>
                                    <div class="ml-2 my-1">{{ "onboarding_welcome_3" | translate }}</div>
                                </div>

                                <div class="flex justify-content mt-12 mb-6">
                                    <p-button
                                        pRipple
                                        type="button"
                                        styleClass="p-button-xl"
                                        (click)="nextStep()"
                                        label="{{ getButtonTitle() | translate }}"
                                        class="p-button-sm"
                                    >
                                    </p-button>
                                </div>
                            </div>
                            <div class="flex items-center justify-center">
                                <img src="/assets/images/setup-box.png" width="375px" height="375px" class="-mt-20 hidden md:block lg:block" alt="Setup box" />
                                <!-- nur anzeigen ab md, auf smartphone ausblenden damit kein horizintales scrollen & text lesbar -->
                            </div>
                        </div>
                    </div>

                    <div *ngIf="currentStep == 2">
                        <!-- Step: Kunden/Projekte hinzufügen -->
                        <h2 class="mb-6">{{ "onboarding_step2_header" | translate }}</h2>
                        <p class="mb-12">{{ "onboarding_step2_intro" | translate }}</p>
                        <div class="video-container mb-4">
                            <iframe
                                [src]="getVideoUrl(2) | safe: 'resourceUrl'"
                                title="YouTube video player"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; modestbranding"
                                allowfullscreen
                                style="border: 0"
                            >
                            </iframe>
                        </div>

                        <div class="flex mt-12 mb-6 justify-end">
                            <p-button
                                pRipple
                                type="button"
                                styleClass="p-button-xl "
                                (click)="nextStep()"
                                label="{{ getButtonTitle() | translate }}"
                                class="p-button-sm"
                            >
                            </p-button>
                        </div>
                    </div>

                    <div *ngIf="currentStep == 3">
                        <!-- Step: Zeit erfassen -->
                        <h2 class="mb-6">{{ "onboarding_step3_header" | translate }}</h2>
                        <p [innerHTML]="'onboarding_step3_intro' | translate"></p>

                        <p-button
                            pRipple
                            type="button"
                            styleClass="p-button"
                            (click)="downloadApp()"
                            icon="pi pi-download"
                            label="{{ 'onboarding_step3_download_button' | translate }}"
                        >
                        </p-button>

                        <div class="mb-12"></div>

                        <div class="video-container mb-4">
                            <iframe
                                width="100%"
                                height="100%"
                                [src]="getVideoUrl(3) | safe: 'resourceUrl'"
                                title="YouTube video player"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; modestbranding"
                                allowfullscreen
                                style="border: 0"
                            >
                            </iframe>
                        </div>

                        <div class="flex mt-12 mb-6 justify-end">
                            <p-button
                                pRipple
                                type="button"
                                styleClass="p-button-xl "
                                (click)="nextStep()"
                                label="{{ getButtonTitle() | translate }}"
                                class="p-button-sm"
                            >
                            </p-button>
                        </div>
                    </div>

                    <div *ngIf="currentStep == 4">
                        <!-- Step: Auswertung machen -->
                        <h2 class="mb-6">{{ "onboarding_step4_header" | translate }}</h2>
                        <p class="mb-12" [innerHTML]="'onboarding_step4_intro' | translate"></p>
                        <div class="video-container mb-4">
                            <iframe
                                width="100%"
                                height="100%"
                                [src]="getVideoUrl(4) | safe: 'resourceUrl'"
                                title="YouTube video player"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; modestbranding"
                                allowfullscreen
                                style="border: 0"
                            >
                            </iframe>
                        </div>

                        <div class="flex mt-12 mb-6 justify-end">
                            <p-button
                                pRipple
                                type="button"
                                styleClass="p-button-xl "
                                (click)="nextStep()"
                                label="{{ getButtonTitle() | translate }}"
                                class="p-button-sm"
                            >
                            </p-button>
                        </div>
                    </div>

                    <div *ngIf="currentStep == 5">
                        <!-- Step: Team verwalten -->
                        <h2 class="mb-6">{{ "onboarding_step5_header" | translate }}</h2>
                        <p class="mb-6" [innerHTML]="'onboarding_step5_intro' | translate"></p>

                        <p-button
                            pRipple
                            type="button"
                            styleClass="p-button"
                            [routerLink]="['/team']"
                            icon="pi pi-users"
                            label="{{ 'onboarding_step5_button' | translate }}"
                        ></p-button>

                        <div class="mb-12"></div>

                        <div class="flex mb-1 justify-center">
                            <img src="{{ 'onboarding_step5_link' | translate }}" alt="Invite members" width="60%" height="60%" />
                        </div>

                        <div class="flex mt-12 mb-6 justify-end">
                            <p-button
                                pRipple
                                type="button"
                                styleClass="p-button-xl "
                                (click)="nextStep()"
                                label="{{ getButtonTitle() | translate }}"
                                class="p-button-sm"
                            >
                            </p-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-span-12 md:col-span-5">
            <div class="box m-12">
                <div class="m-4">
                    <div class="mt-2 mb-6">
                        <div class="mb-12" style="font-weight: bold">
                            <h4>{{ "onboarding_steps_menu_header" | translate }}</h4>
                        </div>
                    </div>

                    <ng-container *ngFor="let step of steps; let i = index">
                        <div class="flex mb-4" *ngIf="step">
                            <div><i class="pi pi-check-circle step-icon-done"></i></div>
                            <div class="ml-4">
                                <s>{{ getTranslatedKey(i) | translate }}</s>
                            </div>
                        </div>

                        <div class="flex mb-4" *ngIf="!step">
                            <div class="step-icon-open"><i class="pi pi-circle-fill"></i></div>
                            <div class="ml-4 step-text-open">{{ getTranslatedKey(i) | translate }}</div>
                        </div>
                        <p-divider></p-divider>
                    </ng-container>

                    <div class="mt-12 flex">
                        <p-button
                            label="{{ 'onboarding_questions_contact' | translate }}"
                            styleClass="p-button-link"
                            (click)="linkToSupport()"
                            icon="pi pi-comments"
                        ></p-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- FINISH CONTAINER -->
<div *ngIf="steps.length > 0 && currentStep == -1">
    <div class="grid grid-cols-12 gap-4 mt-20">
        <div class="col-span-8 md:col-span-3"></div>

        <div class="col-span-8 md:col-span-6 flex justify-center">
            <div class="card box p-12 text-center items-center">
                <img class="mb-6 inline" src="/assets/images/green-check.png" alt="green check" width="15%" />
                <h2 class="text-center mb-6">{{ "onboarding_step_finished_header" | translate }}</h2>

                <div class="mb-8">
                    <p class="text-center mb-6" [innerHTML]="'onboarding_step_finished_sub_header' | translate"></p>
                    <p class="text-center text-base" style="color: #818181">{{ "onboarding_step_finished_body" | translate }}</p>
                </div>

                <div class="flex justify-center mb-6">
                    <p-button
                        pRipple
                        type="button"
                        styleClass="p-button-xl"
                        (click)="finishOnboarding()"
                        label="{{ 'onboarding_button_finish' | translate }}"
                        class="p-button-sm"
                    >
                    </p-button>
                </div>
            </div>
        </div>

        <div class="col-span-8 md:col-span-3"></div>
    </div>
</div>

<!-- FIRST START Dialog: is released after finishing start wizard -->
<p-dialog
    header=""
    [(visible)]="displayFirstStartDialog"
    [style]="{ width: '70vw' }"
    [closable]="false"
    [draggable]="false"
    [closeOnEscape]="false"
    [modal]="true"
>
    <ng-template pTemplate="content">
        <div class="m-12 flex justify-center content-center">
            <div>
                <div class="flex justify-center mt-20">
                    <img src="/assets/images/progress.png" style="width: 400px" alt="Trial started" />
                </div>

                <div class="flex justify-center mt-6">
                    <div class="mx-12 mt-20 mb-20">
                        <h2 class="m-8 text-center">{{ "welcome_dialog_trial_title_left" | translate }}</h2>
                        <p class="mb-4 text-center" [innerHTML]="'welcome_dialog_trial_body_left' | translate"></p>
                    </div>

                    <div class="mx-12 mt-20 mb-12">
                        <h2 class="m-8 text-center">{{ "welcome_dialog_trial_title_right" | translate }}</h2>
                        <p class="mb-12 text-center" [innerHTML]="'welcome_dialog_trial_body_right' | translate"></p>
                        <div class="text-center">
                            <p-button
                                pRipple
                                type="button"
                                styleClass="p-button-lg"
                                (click)="linkToAddons()"
                                label="{{ 'welcome_dialog_trial_button_buy' | translate }}"
                            ></p-button>
                        </div>
                        <div class="text-center mt-4">
                            <p-button
                                styleClass="p-button-text"
                                (click)="hideFirstStartDialog()"
                                label="{{ 'welcome_dialog_trial_button_continue' | translate }}"
                            ></p-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</p-dialog>
<!-- END Dialog: App Download -->
